import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import accountReducer from './accountReducer';
import reportReducer from './reportReducer';
import pdfReducer from './pdfReducer';
import usersReducer from './usersReducer';
import commonReducer from './commonReducer';
import registerReducer from './registerReducer';
import subscriptionReducer from './subscriptionReducer';
import accountAnalysisReducer from './accountAnalysisReducer';
import homeReducer from './homeReducer';
import aggregateAnalysisReducer from './aggregateAnalysisReducer';
import contactReducer from './contactReducer';
import alertReducer from './alertReducer';
import gstrAnalysisReducer from './gstrAnalysisReducer';
import allAggregateReducer from './allAggregateReducer';

const rootReducer = combineReducers({
  account: accountReducer,
  report: reportReducer,
  pdf: pdfReducer,
  users: usersReducer,
  common: commonReducer,
  register: registerReducer,
  subscription: subscriptionReducer,
  accountAnalysis: accountAnalysisReducer,
  home: homeReducer,
  aggregateAnalysis: aggregateAnalysisReducer,
  contact: contactReducer,
  alert: alertReducer,
  gstrAnalysis: gstrAnalysisReducer,
  allAggregateAnalysis: allAggregateReducer
});

export default rootReducer;
